module.exports = __webpack_public_path__ + "img/align-vertical.fcfeb114.svg";